var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "var(--native-icon-fill)",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3 2.4a.7.7 0 0 1 .7.7v11.2a.7.7 0 0 1-.7.7H1.7a.7.7 0 0 1-.7-.7V3.1a.7.7 0 0 1 .7-.7h2.8V1h1.4v1.4h4.2V1h1.4v1.4h2.8ZM5.9 3.8v1.4H4.5V3.8H2.4v2.8h11.2V3.8h-2.1v1.4h-1.4V3.8H5.9ZM2.4 8v5.6h11.2V8H2.4Z"
  })));
};

export default SvgCalendar;